import React, {useEffect, useRef, useState} from 'react';

import {Container} from "/src/_v2/ui/layout/Container";
import {Section} from "/src/_v2/ui/layout/Section";

import {TextHighlited} from "/src/_v2/ui/primitives/TextHighlited";
import {Tag} from "/src/_v2/ui/primitives/Tag";

import {Button} from "/src/components/global/Button";
import {Line} from "/src/components/global/Line";

import Typed from "typed.js";

export const IntroSection = (props) => {
  const data = props.data;

  const labelRef = useRef(null);
  const imgRef = useRef(null);


  const [line, setLine] = useState(null);
  const textBlock = useRef(null);

  const typedOptions = {
    showCursor:false,
    typeSpeed: 30,
  };
  let typed = [
    {
      text : data.titlePart1,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart2,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart3,
      ref : useRef(null),
      typed : useRef(null)
    },
  ];
  const LineX = () =>{
    return <Line color={"#FF9100"} start={typed[2].ref} end={labelRef}/>;
  };
  //Typed
  useEffect(() => {
    let nextWordDelay = 0;
    typed.forEach((item, index) => {
      if (index !== 0) {
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed;
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay: nextWordDelay,
        strings: [
          item.text
        ],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('tw:opacity-0')
        },
        onComplete: (self) => {
          if (index === typed.length - 1) {
            setLine(<LineX/>);
            textBlock.current.classList.remove('tw:opacity-0')
            imgRef.current.classList.remove('tw:opacity-0')
          }
        },
      });
    })
    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.forEach((item, index) => {
        item.typed.current.destroy();
      });
    }
  }, []);


  return (
    <Section className={`tw:min-h-570 tw:md:min-h-678 tw:lg:min-h-665 tw:xl:min-h-770`}>
      <Container>
        <div className="tw:grid tw:md:grid-cols-12 tw:gap-y-48 tw:lg:gap-y-40 tw:gap-x-24 tw:relative">
          <h1
            className="tw:md:col-span-8 tw:lg:col-span-7 tw:xl:col-span-8 tw:m-0 tw:flex tw:gap-6 tw:flex-wrap tw:relative tw:z-10">
            <TextHighlited color="purple" className={`tw:opacity-0`} ref={typed[0].ref}></TextHighlited>
            <TextHighlited color="white" className={`tw:opacity-0`} ref={typed[1].ref}></TextHighlited>
            <TextHighlited color="orange" className={`tw:opacity-0`} ref={typed[2].ref}></TextHighlited>
          </h1>
          <div
            className="tw:md:col-start-5 tw:md:col-span-8 tw:lg:col-start-7 tw:lg:col-span-6 tw:xl:col-start-7 tw:xl:col-span-4 tw:flex tw:gap-24 tw:items-start tw:relative tw:opacity-0 tw:transition-opacity tw:duration-300"
            ref={textBlock}>
            <Tag color="orange" className={`tw:lg:absolute tw:lg:top-0 tw:lg:right-full tw:lg:mr-24`}
                 ref={labelRef}>{data.number}</Tag>
            <div className="tw:flex tw:flex-col tw:gap-24 tw:items-start">
              {data.text && (
                <p className="tw:subtitle4">{data.text}</p>
              )}
              <Button
                title={data.link.title}
                url={data.link.url}
                classes="btn-lg"
                external={data.link.target === '_blank'}
                icon={'arrow-down-r-dotted-rd'}
              />
            </div>

          </div>
          <img ref={imgRef} width="473" height="395" src={`/assets/_rd/pages/merged-mining/mining-intro.svg`}
               alt="Merged Mining"
               className="tw:absolute tw:hidden tw:lg:block tw:-top-18 tw:right-1/12 tw:z-0 tw:h-auto tw:lg:w-350 tw:xl:w-473 tw:opacity-0 tw:transition-opacity tw:duration-300"/>

        </div>
        {line}
      </Container>
    </Section>
  )
}
